import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import VueMask from 'di-vue-mask'

Vue.use(VueMask)
Vue.config.productionTip = false

if(window.CONFIG.SENTRY.DSN) {
  Sentry.init({
    dsn: window.CONFIG.SENTRY.DSN,
    environment: window.CONFIG.SENTRY.ENV,
    integrations: [new Integrations.Vue({Vue, attachProps: true})]
  })
}

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
